import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKSlasher = () => (
  <ArticleWrapper articleId="gmk_slasher">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Slasher</h1>
        {/* Add your GMK Slasher article content here */}
        <p>This is a placeholder article for the GMK Slasher keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKSlasher;
